import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { isNull } from 'lodash'
import WayPoint from 'react-waypoint'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'

import { loadSwaps, loadMoreSwaps, unloadSwaps, hideSwap } from '../../actions'
import {
  getSwaps,
  canLoadMoreSwaps,
  getTotalSwaps,
  getSwapsLoading,
} from '../../selectors'
import Spinner from '../../common/Spinner'
import NoResults from '../../common/NoResults'
import ExchangeCard from '../../common/ExchangeCard'
import SwapsTabs from '../../common/SwapsTabs'

import MediaQuery from 'react-responsive'
import breakpoints from '../../styles/breakpoints'
import { themeColors } from '../../styles/theme'
import withTopBar from '../../common/TopBar/withTopBar'

class Swaps extends PureComponent {
  state = {
    // Swap we are goint to hide
    swapToHide: false,
  }

  componentDidMount() {
    this.props.loadSwaps({
      type: this.props.match.params.type,
    })
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.type !== nextProps.match.params.type) {
      this.props.unloadSwaps()
      this.props.loadSwaps({
        type: nextProps.match.params.type,
      })
    }
  }

  componentWillUnmount() {
    this.props.unloadSwaps()
  }

  loadMore = () => {
    this.props.loadMoreSwaps({
      type: this.props.match.params.type,
    })
  }

  onHideClick = swap => {
    this.setState({ swapToHide: swap })
  }

  handleCloseHideDialog = () => {
    this.setState({ swapToHide: null })
  }

  hideSwap = () => {
    this.props.hideSwap(this.state.swapToHide.id)
    this.handleCloseHideDialog()
  }

  render() {
    const {
      swaps,
      loading,
      canLoadMoreSwaps,
      match,
      performingAction,
    } = this.props

    return (
      <div>
        <MediaQuery minWidth={breakpoints.sm}>
          <SwapsTabs type={match.params.type} />
        </MediaQuery>
        <div className="SwapsPage">
          {/* Loading swaps spinner */}
          {loading && isNull(swaps) && <Spinner centered />}

          {!isNull(swaps) &&
            swaps.length > 0 &&
            <div>
              {swaps.map(swap => (
                <ExchangeCard
                  key={swap.id}
                  swap={swap}
                  loading={performingAction[swap.id]}
                  onHideClick={this.onHideClick}
                />
              ))}
            </div>}

          {!loading &&
            !isNull(swaps) &&
            swaps.length === 0 &&
            <NoResults>
              Non hai effetuato ancora nessuno scambio
            </NoResults>}

          {/*  Loading more swaps spinner */}
          {loading &&
            !isNull(swaps) &&
            swaps.length > 0 &&
            <Spinner centered />}

          {/* Trigger load more */}
          {!loading &&
            !isNull(swaps) &&
            swaps.length > 0 &&
            canLoadMoreSwaps &&
            <WayPoint onEnter={this.loadMore} />}
        </div>
        <MediaQuery maxWidth={breakpoints.sm}>
          <SwapsTabs type={match.params.type} />
        </MediaQuery>
        <Dialog
          title="Eliminazione scambio"
          titleStyle={{ backgroundColor: themeColors.lightBackground }}
          contentClassName="fullwidth-for-small"
          actions={[
            <FlatButton
              label="Annulla"
              primary={true}
              onClick={this.handleCloseHideDialog}
            />,
            <FlatButton
              label="Elimina"
              primary={true}
              keyboardFocused={true}
              onClick={this.hideSwap}
            />,
          ]}
          modal={true}
          open={this.state.swapToHide}
          onRequestClose={this.handleCloseHideDialog}>
          <p>Confermi l'eliminazione dello scambio?</p>
        </Dialog>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  swaps: getSwaps(state),
  totalSwaps: getTotalSwaps(state),
  canLoadMoreSwaps: canLoadMoreSwaps(state),
  loading: getSwapsLoading(state),
  performingAction: state.swaps.performingActionById,
})

export default withTopBar({
  title: 'Proposte',
})(
  connect(mapStateToProps, {
    loadSwaps,
    loadMoreSwaps,
    unloadSwaps,
    hideSwap,
  })(Swaps)
)



// WEBPACK FOOTER //
// ./src/pages/Me/Swaps.js